import { Utils } from 'cc-common';

export class WFEBaseParametersDto {
    workflowId: number;
    communityId: number; // 	NOTE: Required for most endpoints of workflow editor except for getting communities, workflow history and downloading invoice
    workflowStatus: string; // 	NOTE: Required for most endpoints of workflow editor except for getting data entry editor
    clearCache = false;

    getQueryString(): string {
        let url = `?workflowId=${this.workflowId}&workflowStatus=${this.workflowStatus}&clearCache=${this.clearCache}`;

        if (Utils.notNullOrEmpty(this.communityId)) {
            url += `&communityId=${this.communityId}`;
        }

        return url;
    }
}
